import { DAO } from "./DAO";
import { F01Cache } from "./F01Cache";




export class F01CacheDAO {

  static async FetchByMemberGuid(member_guid: string): Promise<F01Cache | null> {
    let rslt = await DAO.Select(F01Cache, " WHERE member_guid='" + member_guid + "' ");

    if (rslt.length == 0) {
      return null;
    } else if (rslt.length == 1) {
      return rslt[0];
    } else {
      throw new Error("4040894 重複的 member_guid: " + member_guid + " !!!");
    }

  }

  static async Insert(data: F01Cache): Promise<F01Cache> {
    let refetch_data = await DAO.Insert(F01Cache, data);
    return refetch_data;
  }

  static async Delete(data: F01Cache): Promise<number> {
    let effect_rows_cnt = DAO.DeleteByGuid(F01Cache, data.guid);
    return effect_rows_cnt;
  }

}